import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { AuthService, CookieConsentService } from '@twaice-fe/frontend/shared/services';
import { SvgIconModule } from '@twaice-fe/frontend/shared/ui-components';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { Subject, take, takeUntil } from 'rxjs';

@Component({
  selector: 'twaice-fe-account-overview',
  templateUrl: './account-overview.component.html',
  imports: [
    CommonModule,
    SvgIconModule,

    NzButtonModule,
    NzFormModule,
    NzInputModule,
    FormsModule,
    NzMenuModule,
    NzCheckboxModule,
    NzMenuModule,
  ],
})
export class AccountOverviewComponent implements OnDestroy {
  username: string;
  cookieChoice: boolean;
  showMfaOption: boolean;

  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private cookieConsentService: CookieConsentService
  ) {
    this.cookieConsentService
      .getChoices()
      .pipe(takeUntilDestroyed())
      .subscribe((choice) => {
        this.cookieChoice = choice;
      });

    this.authService
      .getUserObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.showMfaOption = this.authService.isMfaEnabled() && user.preferredMFA === 'NOMFA';
        this.username = user?.username;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeCookiePreference(optIn: boolean): void {
    this.cookieConsentService
      .setCookieChoice(optIn)
      .pipe(take(1))
      .subscribe(() => {
        // reloading is the only way we can make sure all trackers are properly turned on/off
        location.reload();
      });
  }
}
